/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 document.addEventListener('variant:changed', function(event) {
    var variant = event.detail.variant; // Gives you access to the whole variant details
    var selectedVariantId = variant.id;
    var metafieldElements = document.querySelectorAll(".variant-metafields");

    metafieldElements.forEach(function (element) {
      element.style.display = "none"; // Hide everything first
    });

    var selectedElement = document.querySelector('.variant-metafields[data-variant-id="' + selectedVariantId + '"]');
    if (selectedElement) {
        selectedElement.style.display = "block";
    }
});

document.addEventListener("DOMContentLoaded", function () {
    // Attach click listener to gallery images associated with variants
    document.querySelectorAll('[data-variant-id]').forEach(function (img) {
      img.addEventListener('click', function () {
        const variantId = img.getAttribute('data-variant-id');

        // Find the variant selector
        const variantSelect = document.querySelector('form[action^="/cart/add"] select[name="id"]');
        if (!variantSelect) return;

        // Change the selected variant
        const match = [...variantSelect.options].find(opt => opt.value === variantId);
        if (match) {
          variantSelect.value = variantId;
          variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // OPTIONAL: update the URL to reflect the new variant
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.set('variant', variantId);
        window.history.replaceState({}, '', newUrl);
      });
    });
  });